import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

const navItems = [
  { path: '/',            label: 'Dashboard',  icon: '⬡' },
  { path: '/members',     label: 'Members',    icon: '◈' },
  { path: '/attendance',  label: 'Attendance', icon: '◉' },
  { path: '/payments',    label: 'Payments',   icon: '⬡' },
  { path: '/supplements', label: 'Supplements',icon: '◈' },
  { path: '/expenses',    label: 'Expenses',   icon: '◉' },
  { path: '/reports',     label: 'Reports',    icon: '⬡' },
  { path: '/settings',    label: 'Settings',   icon: '◈' },
];

function Sidebar({ isOpen, setIsOpen }) {
  const { logout } = useAuth();
  const { isDark } = useTheme();

  const inactiveColor  = isDark ? 'rgba(255,255,255,0.45)' : '#607A90';
  const dividerColor   = isDark ? 'rgba(0,255,240,0.10)' : 'rgba(0,168,158,0.12)';

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-20 bg-black bg-opacity-70 lg:hidden backdrop-blur-sm"
          onClick={() => setIsOpen(false)}
        />
      )}
      <aside
        className={`fixed top-0 left-0 h-full w-60 z-30 flex flex-col transform transition-all duration-300 lg:translate-x-0 lg:static lg:z-auto ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}
        style={{ background: 'var(--sidebar-bg)', borderRight: `1px solid var(--sidebar-border)` }}
      >
        {/* Logo */}
        <div className="flex items-center gap-3 px-5 py-5 flex-shrink-0" style={{ borderBottom: `1px solid ${dividerColor}` }}>
          <div
            className="w-9 h-9 rounded-xl flex items-center justify-center text-base font-black flex-shrink-0"
            style={{ background: 'var(--aqua)', color: '#040810', boxShadow: '0 0 14px var(--aqua-glow)' }}
          >
            G
          </div>
          <div>
            <div className="font-bold text-sm leading-tight" style={{ color: 'var(--aqua)' }}>GymPro</div>
            <div className="text-xs" style={{ color: 'var(--text-muted)' }}>Management System</div>
          </div>
        </div>

        {/* Nav */}
        <nav className="mt-3 px-3 flex-1 overflow-y-auto space-y-0.5">
          {navItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              onClick={() => setIsOpen(false)}
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all"
              style={({ isActive }) => isActive ? {
                background: 'var(--aqua-dim)',
                color: 'var(--aqua)',
                borderLeft: '2px solid var(--aqua)',
                paddingLeft: '10px',
              } : {
                color: inactiveColor,
                borderLeft: '2px solid transparent',
              }}
            >
              <span className="text-xs opacity-50">{item.icon}</span>
              <span className="tracking-wide">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* Logout */}
        <div className="px-3 py-4 flex-shrink-0" style={{ borderTop: `1px solid ${dividerColor}` }}>
          <button
            onClick={logout}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all"
            style={{ color: inactiveColor }}
            onMouseEnter={e => { e.currentTarget.style.color = '#EF4444'; e.currentTarget.style.background = 'rgba(239,68,68,0.08)'; }}
            onMouseLeave={e => { e.currentTarget.style.color = inactiveColor; e.currentTarget.style.background = 'transparent'; }}
          >
            <span className="text-xs">⬡</span>
            <span className="tracking-wide">Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
